(() => {
  if (customElements.get('atwill-size-chart')) return;
  class AtwillSizeChart extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.unit = 'in';
      this.highlight(this.dataset.selectedSize);
      const units = this.querySelector('[data-unit-controls]');
      if (units) units.hidden = false;
      this.addEventListener('click', event => {
        if (event.target.closest('[data-size-close]')) this.dialog.close();
        const button = event.target.closest('[data-unit]');
        if (button) {
          this.unit = button.dataset.unit;
          this.querySelectorAll('[data-unit]').forEach(el => el.setAttribute('aria-pressed',String(el === button)));
          this.querySelector('[data-unit-name]').textContent = button.dataset.unitLabel || button.textContent;
          this.querySelectorAll('[data-inch]').forEach(cell => {
            const inches = Number(cell.dataset.inch);
            const max = cell.dataset.inchMax;
            if (max !== undefined) {
              cell.textContent = this.unit === 'cm' ? `${Math.round(inches*25.4)/10}–${Math.round(Number(max)*25.4)/10} cm` : `${inches}–${max}″`;
            } else {
              cell.textContent = this.unit === 'cm' ? `${cell.dataset.cm || Math.round(inches*25.4)/10} cm` : `${inches}″`;
            }
          });
        }
        if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }
      });
      this.dialog.addEventListener('close', () => {
        this.unlockScroll();
        if (this.opener?.isConnected) this.opener.focus({preventScroll:true});
      });
    }
    highlight(value) {
      const aliases = {small:'S',medium:'M',large:'L','extra large':'XL','extra-large':'XL','x-large':'XL',s:'S',m:'M',l:'L',xl:'XL'};
      const selected = aliases[String(value || '').trim().toLowerCase()] || '';
      this.querySelectorAll('[data-chart-size]').forEach(cell => {
        const active = cell.dataset.chartSize === selected;
        cell.classList.toggle('aw-size__selected',active);
        if (cell.tagName === 'TH') {
          if (active) cell.setAttribute('aria-current','true');
          else cell.removeAttribute('aria-current');
        }
      });
    }
    open(opener) {
      if (this.dialog.open) return;
      this.opener = opener;
      const quickbuy = opener.closest('[data-product-quickshop]');
      if (quickbuy) {
        const selector = quickbuy.querySelector('[data-component="options-selector"]');
        const options = selector?.querySelectorAll('[data-component="input-fieldset"], [data-component="input-select"]');
        const sizeOption = options?.[Number(this.dataset.sizeIndex)];
        const selected = sizeOption?.querySelector('input:checked, select');
        if (selected) this.highlight(selected.value);
      }
      this.previousOverflow = document.documentElement.style.overflow;
      this.dialog.showModal();
      this.previousBodyOverflow = document.body.style.overflow;
      this.scrollController = window.lenis;
      this.resumeScroll = this.scrollController && !this.scrollController.isStopped;
      if (this.resumeScroll) this.scrollController.stop();
      this.scrollLocked = true;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }
    unlockScroll() {
      if (!this.scrollLocked) return;
      this.scrollLocked = false;
      document.documentElement.style.overflow = this.previousOverflow || '';
      document.body.style.overflow = this.previousBodyOverflow || '';
      if (this.resumeScroll) this.scrollController.start();
    }
    disconnectedCallback() {
      this.unlockScroll();
    }
  }
  customElements.define('atwill-size-chart',AtwillSizeChart);
  document.addEventListener('product:variant-change',event => {
    const root = event.target.closest('[data-product-quickshop], .atwill-b2');
    if (!root) return;
    root.querySelectorAll('atwill-size-chart').forEach(chart => {
      chart.dataset.selectedSize = event.detail?.variant?.options?.[Number(chart.dataset.sizeIndex)] || '';
      chart.highlight(chart.dataset.selectedSize);
    });
  });
  let suppressEscapeRelease = false;
  window.addEventListener('keydown', event => {
    const dialog = document.querySelector('.aw-size__dialog[open]');
    if (!dialog) return;
    if (event.key === 'Tab') event.stopImmediatePropagation();
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopImmediatePropagation();
      suppressEscapeRelease = true;
      dialog.close();
    }
  }, true);
  window.addEventListener('keyup', event => {
    if (event.key === 'Escape' && suppressEscapeRelease) {
      event.stopImmediatePropagation();
      suppressEscapeRelease = false;
    }
  }, true);
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-size-open]');
    if (!trigger) return;
    const dialog = document.getElementById(trigger.dataset.sizeOpen);
    const chart = dialog?.closest('atwill-size-chart');
    if (chart) {
      event.preventDefault();
      chart.open(trigger);
    }
  }, true);
})();
